import { TextMediumSM } from "../../../../../Components/Text/MediumText"
import ApprovalStatus from "./ApprovalStatus";
import Priority from "./Priority";
import Status from "./Status";




const RFQ = () =>{
    return(
        <>
        <TextMediumSM content="RFQ" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Priority/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Status/>
         </div>
         </div>
         </>
    )
}

export default RFQ;